export const darkTheme = {
  // appbg: "#575757",
  appbg: "#1B1B1D",
  cardbg: "#1E1E1E",
  textprimary: "#FFFFFF",
  textsecondary: "#94A3B8",
  bordercolor: "#2D2D2D",
  actionitembg: "#262626",
  dashboardbg: "#121212",
  primaryaccent: "#FF4D4F",
  secondaryaccent: "#2B2B2D",
  accentborder: "#363638",
  breadcrumbactive: "#FFFFFF",
  breadcrumbinactive: "#A0A0A2",
  sectionheaderbg: "#1E1E1E",
  tabletext: "#FFFFFF"
};

export const lightTheme = {
  appbg: "#FFEFEF",
  cardbg: "#FFFFFF",
  textprimary: "#0F172A",
  textsecondary: "#64748B",
  bordercolor: "#F1F5F9",
  actionitembg: "#F2FAFF",
  dashboardbg: "#FFFFFF",
  primaryaccent: "#E31F26",
  secondaryaccent: "#FFEFEF",
  accentborder: "transparent",
  breadcrumbactive: "#1E293B",
  breadcrumbinactive: "#64748B",
  sectionheaderbg: "#F8FAFC",
  tabletext: "#1E293B"
};
